import React from "react";
import { Modal } from "react-bootstrap";
import CreateTrialForm from "./CreateTrialForm";


const CreateFreeTrialParent = (props) => {
  const closeModal = () => {
    props.setModalOpen(false);
    props.setFormData({
      customerName: "",
      companyName: "",
      phoneNumber: "",
      emailId: "",
      password: "",
      products: [],
    });
  };

  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header>
        <Modal.Title>
          Create a Trial Account
          <button
            type="button"
            onClick={closeModal}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "none",
              border: "none",
              fontSize: "16px",
              cursor: "pointer",
              color: "#333",
            }}
            aria-label="Close"
          >
            ✖
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateTrialForm
          mailTriggerPopup={props.mailTriggerPopup}
          formData={props.formData}
          setFormData={props.setFormData}
          apiUrl={props.apiUrl}
          setApiUrl={props.setApiUrl}
          productOptions={props.productOptions}
          fixedCustomerDetails={props.fixedCustomerDetails || false}
          closeModal={closeModal}
          mautic_id={props.mautic_id}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CreateFreeTrialParent;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/CreateFreeTrialParent.js